import { useQuery, useMutation } from "@tanstack/react-query";
import {
  createSavedSearch,
  CreateSavedSearchRequest,
  deleteSavedSearch,
  getAllSavedSearches,
  getSavedSearch,
  updateSavedSearch,
  UpdateSavedSearchRequest,
} from "../api/savedSearch";
import { SavedSearch } from "../types/saved-search/SavedSearch";
import { queryClient } from "../App";

export const useGetSavedSearches = (customerId: string, userId: string) => {
  return useQuery({
    queryKey: ["savedSearches", customerId, userId],
    queryFn: () => getAllSavedSearches(customerId),
    enabled: !!customerId,
  });
};

export const useGetSavedSearch = (
  customerId?: string,
  savedSearchId?: string
) => {
  return useQuery<SavedSearch | undefined, Error>({
    queryKey: ["savedSearches", customerId, savedSearchId],
    queryFn: () => getSavedSearch(customerId!, savedSearchId!),
    enabled: !!customerId && !!savedSearchId,
  });
};

export const useCreateSavedSearch = () => {
  return useMutation({
    mutationKey: ["createSavedSearch"],
    mutationFn: (request: CreateSavedSearchRequest) =>
      createSavedSearch(request),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["savedSearches", variables.customerId],
      });
    },
  });
};

export const useUpdateSavedSearch = () => {
  return useMutation({
    mutationKey: ["updateSavedSearch"],
    mutationFn: (request: UpdateSavedSearchRequest) =>
      updateSavedSearch(request),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["savedSearches", variables.customerId],
      });
    },
  });
};

export const useDeleteSavedSearch = () => {
  return useMutation({
    mutationKey: ["deleteSavedSearch"],
    mutationFn: ({
      customerId,
      savedSearchId,
    }: {
      customerId: string;
      savedSearchId: string;
    }) => deleteSavedSearch(customerId, savedSearchId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["savedSearches", variables.customerId],
      });
    },
  });
};
